/**
 * Multi-site helpers.
 *
 * Client rule: a firm with more than one site keeps no saved payment methods. Cards and bank
 * accounts sit on the customer's one Stripe customer, so every site would share them; for a
 * multi-site firm each payment method is used for one payment and removed afterwards.
 */

/**
 * Whether the active customer has more than one site (the same test as the header's site label).
 * Pass `useAuthStore((s) => s.selectedCompany?.sites)`.
 *
 * @param {Array<object> | null | undefined} sites
 * @returns {boolean}
 */
export function hasMultipleSites(sites) {
  return Array.isArray(sites) && sites.length > 1;
}
